import { render, staticRenderFns } from "./LinkTaskDetail.vue?vue&type=template&id=683153dc&scoped=true&"
import script from "./LinkTaskDetail.vue?vue&type=script&lang=tsx&"
export * from "./LinkTaskDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./LinkTaskDetail.vue?vue&type=style&index=0&id=683153dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683153dc",
  null
  
)

export default component.exports